import { aws } from './awsdb';

export async function logPoActivity(poId, session, action, detail) {
  if (!poId || !session) return;
  const { error } = await aws.from('po_activity_log').insert([{
    po_id: poId,
    actor_name: session.name,
    action,
    detail: detail || null
  }]);
  if (error) console.warn('[po-activity-log] insert failed:', error.message);
}

export function formatPoActivityWhen(ts) {
  if (!ts) return '';
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('en-AU', {
    day: 'numeric', month: 'short', year: 'numeric',
    hour: 'numeric', minute: '2-digit', hour12: true
  }).toLowerCase();
}

const STATUS_LABELS = {
  draft: 'Draft', approved: 'Approved',
  disputed: 'Disputed', paid: 'Paid'
};

function humanStatus(code) { return STATUS_LABELS[code] || code; }

// Format an invoice-level activity entry with the invoice number woven in naturally
export function humanInvoiceAction(entry, invNum) {
  const raw = entry.action_type || '';
  const tag = invNum || '';
  const amount = entry.after_value || '';
  const method = entry.notes || '';

  switch (raw) {
    case 'invoice_created':
      return { text: `Created invoice ${tag}`, invNum: tag };
    case 'invoice_edited': {
      const fields = entry.notes ? ` (${entry.notes})` : '';
      return { text: `Edited invoice ${tag}${fields}`, invNum: tag };
    }
    case 'payment_logged': {
      const parts = [amount, method].filter(Boolean).join(' via ');
      return { text: `Payment logged ${parts} on ${tag}`, invNum: tag };
    }
    case 'payment_deleted': {
      const val = entry.before_value || amount || '';
      return { text: `Deleted payment${val ? ` ${val}` : ''} on ${tag}`, invNum: tag };
    }
    case 'status_change':
      return { text: `Changed ${tag} status to ${humanStatus(entry.after_value || '')}`, invNum: tag };
    case 'marked_disputed': {
      const reason = entry.notes ? ` — ${entry.notes}` : '';
      return { text: `Marked ${tag} as disputed${reason}`, invNum: tag };
    }
    case 'attachment_added':
      return { text: `Attached file${amount ? ` ${amount}` : ''} to ${tag}`, invNum: tag };
    case 'attachment_deleted':
      return { text: `Removed file${entry.before_value ? ` ${entry.before_value}` : ''} from ${tag}`, invNum: tag };
    case 'line_items_updated':
      return { text: `Updated line items on ${tag}${amount ? ` (${amount})` : ''}`, invNum: tag };
    default:
      return { text: `${raw}${tag ? ` on ${tag}` : ''}`, invNum: tag };
  }
}

// Format a PO-level activity entry (already human-readable action strings)
export function humanPoAction(entry) {
  const raw = entry.action || '';
  const detail = entry.detail || '';
  if (detail) return `${raw} — ${detail}`;
  return raw;
}
